/**
 * Подписывается на публичный канал прямого эфира комментариев, обновляет фид комментариев в сайдбаре
 */

import LiveFeed from "../../../../components/live/live-feed";

const subscriber = (rt) => {
  rt.subscribePublic("comments", data => {
    if (data.comment) {
      LiveFeed.updateFeed(data.comment);
    }
  });
};

export default subscriber;